import { render } from "./DocumentsView.vue?vue&type=template&id=3b3fba0c&scoped=true"
import script from "./DocumentsView.vue?vue&type=script&lang=js"
export * from "./DocumentsView.vue?vue&type=script&lang=js"

import "./DocumentsView.vue?vue&type=style&index=0&id=3b3fba0c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3b3fba0c"

export default script